import { DevHubButton, DevHubDynamicIcon } from '@devxdiscover/devhub-ui';

enum ViewMode {
  List = 'list',
  Tile = 'tile',
}

/**
 * This is a component that toggles between list and tile views
 * @param props the props of the component
 * @param props.onViewChange function to change the view between list and tile views
 * @param props.viewMode enum that determines if the view is list or tile
 */
export const ViewToggleButton = ({
  onViewChange,
  viewMode,
}: {
  onViewChange: (arg0: ViewMode) => void;
  viewMode: ViewMode;
}) => {
  const toggleView = () => {
    let newViewMode: ViewMode;
    if (viewMode === ViewMode.List) {
      newViewMode = ViewMode.Tile;
    } else {
      newViewMode = ViewMode.List;
    }
    localStorage.setItem('myAppsViewMode', newViewMode);

    onViewChange(newViewMode);
  };

  return (
    <>
      {viewMode === ViewMode.List ? (
        <>
          <DevHubButton onClick={toggleView} variant="outlined">
            <DevHubDynamicIcon iconName="Apps" />
            Switch to Tile View
          </DevHubButton>
        </>
      ) : (
        <>
          <DevHubButton onClick={toggleView} variant="outlined">
            <DevHubDynamicIcon iconName="Menu" />
            Switch to List View
          </DevHubButton>
        </>
      )}
    </>
  );
};
